import { useTranslation } from "react-i18next";
import { List, Paper, Typography } from "@material-ui/core";
import styled from "styled-components";
import { NotificationEvent } from "@dashboard-v3/api";
import NotificationItem from "./Item";

const StyledPaper = styled(Paper)`
  min-height: 100px;
  align-self: start;
  align-items: center;
  display: grid;
  padding: 16px;
  text-align: center;
`;

const StyledList = styled(List)`
  li:first-child {
    padding-top: 0;
  }
  li:last-child {
    padding-bottom: 0;
  }
`;

type ListProps = {
  notifications: NotificationEvent[];
};

export default function NotificationList({ notifications }: ListProps) {
  const { t } = useTranslation("notifications");

  if (!notifications) return null;

  if (notifications.length === 0) {
    return (
      <StyledPaper>
        <Typography>{t("noNotificationsToList")}</Typography>
      </StyledPaper>
    );
  }

  return (
    <StyledList disablePadding>
      {notifications.map((notification, i) => (
        <NotificationItem notification={notification} key={notification.id} />
      ))}
    </StyledList>
  );
}
